const ConfirmAccount = () =>
  import(/* webpackChunkName: "auth" */ "@/views/auth/confirm-account/ConfirmAccountPage.vue");

const confirmAccount = [
  {
    path: "/confirm-account/:token",
    name: "ConfirmAccount",
    component: ConfirmAccount,
  },
];

export default confirmAccount;
